import { ANALYTICS_SMALL_VIEW_SUBMIT } from "../constants";
import { getPendingAnalyticsEvents } from "../selectors";
import {
  clearBufferedRefinementEvent,
  isRefinementEvent,
  refinementEvent,
} from "./refinementEvents";
import { analyticsViewListItem } from "./index";

const applyAndRemovePendingEvents = () => (dispatch, getState) => {
  const {
    refinementPendingActionType,
    refinementPendingPayload,
    smallViewSubmitPayload,
  } = getPendingAnalyticsEvents(getState());

  if (isRefinementEvent(refinementPendingActionType)) {
    dispatch(
      refinementEvent(refinementPendingActionType, refinementPendingPayload),
    );
    dispatch(analyticsViewListItem());
  }

  if (smallViewSubmitPayload) {
    dispatch(
      refinementEvent(ANALYTICS_SMALL_VIEW_SUBMIT, smallViewSubmitPayload),
    );
  }

  dispatch(clearBufferedRefinementEvent());
};

export { applyAndRemovePendingEvents as default };
